// Copyright (c) 2026 PGNS LLC

import * as Sentry from '@sentry/react';
import { RouterProvider } from '@tanstack/react-router';
import { ThemeProvider } from '@pgns/ui/theme-provider';
import { router } from './router';

export function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <p className="p-8 text-center">
          The status page failed to render. The JSON API at /v1/summary is unaffected.
        </p>
      }
    >
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  );
}
